import type { PiniaPlugin } from "pinia";
import { cloneDeep } from "lodash-es";

export const resetStore: PiniaPlugin = ({ store }) => {
  const initialState = cloneDeep(store.$state);

  store.$reset = () => store.$patch(cloneDeep(initialState));
};
